module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/zh-hant_3-f69036a542080db534d7270e79ab2fe8.jpg";